import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { Regions } from '../models/regions';

export default ({ region, isActive }) => {
    return (
      <View style={ isActive ? styles.activeRegion : styles.region }>
        <View style={styles.names}>
            <View style={styles.code}>
                <Text style={styles.codeText} >{region.code}</Text>
            </View>
            <View style={styles.name}>
                <Text style={styles.nameText}>{region.name}</Text>
            </View>
        </View>
        <View style={styles.count}>
            <Text style={styles.countText}>{region.markets ? region.markets.length : 0}</Text>
        </View>
      </View>
    );
  }

const styles = StyleSheet.create({
    region: {
        borderWidth: 1,
        margin: 5,
        borderRadius: 15,
        padding: 10,
        backgroundColor: "#b6bad6",
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    activeRegion: {
        borderWidth: 1,
        margin: 5,
        borderRadius: 15,
        padding: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: "#cccc77"
    },
    names: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    name: {
        marginLeft: 10
    },
    nameText: {
        fontSize: 25
    },
    code: {
        width: 30,
        height: 30,
        backgroundColor: 'white',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 5
    },
    codeText: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#333333'
    },
    count: {
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center'
    },
    countText: {
        fontSize: 20,
        color: '#868Aa6'
    }

})
